import styled from "styled-components";
import { FlexColumn } from "styles/layout";
import { Theme } from "theme";

export const ListContainer = styled(FlexColumn)<{
  childHover: boolean;
  hoverColor?: string;
  lastChildBorder: boolean;
}>`
  > * {
    border-bottom: ${Theme.panelContentBorder};
    ${({ lastChildBorder }) =>
      !lastChildBorder &&
      `&:last-child {
      border-bottom: 0;
    }`}
    ${({ childHover, hoverColor }) =>
      childHover &&
      `&:hover {
      background: ${hoverColor ?? Theme.panelHoverBackground}};
    }`}
  }
`;
